import { render, staticRenderFns } from "./BaseBreadcrumbView.vue?vue&type=template&id=1a367014&scoped=true&"
import script from "./BaseBreadcrumbView.vue?vue&type=script&lang=js&"
export * from "./BaseBreadcrumbView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a367014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VExpandTransition})
